import React, { useState } from "react";
import { Modal } from "antd";

const TextBreak = ({ text, limit = 30, title = "Details" }) => {
  const [open, setOpen] = useState(false);

  const isLong = text?.length > limit;

  return (
    <>
      <span
        style={{ cursor: isLong ? "pointer" : "default", color: "#fff" }}
        onClick={() => isLong && setOpen(true)}
      >
        {isLong ? text.substring(0, limit) + "..." : text}
      </span>

      <Modal
        title={title} //  dynamic title
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        maskClosable={false}
        maskStyle={{
          backdropFilter: "blur(8px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        }}
        styles={{
          content: {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            color: "white",
          },
          header: {
            backgroundColor: "transparent",
          },
        }}
      >
        <p style={{ wordBreak: "break-word" }}>{text}</p>
      </Modal>
    </>
  );
};

export default TextBreak;
